module.exports = __webpack_public_path__ + "img/bt_linkedin_hover.483aae02.svg";